import { Component, inject } from '@angular/core';
import { WindowLocationService } from '@app/core/services/window-location.service';
import { ButtonComponent } from '@app/shared/ui/button/button.component';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  imports: [TranslocoPipe, ButtonComponent],
  template: `
    <div class="update-needed">
      <div class="update-needed__hero">
        <img src="/assets/branded/img/logo.svg" class="update-needed__logo" [alt]="'common.alt-image' | transloco" />
        <svg class="update-needed__wave" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 80" preserveAspectRatio="none">
          <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="white" />
        </svg>
      </div>
      <div class="update-needed__content">
        <h2 class="update-needed__title">{{ 'update.update-needed-title' | transloco }}</h2>
        <p class="update-needed__text">{{ 'update.update-needed' | transloco }}</p>
        <div class="update-needed__actions">
          <c-button [icon]="icon" iconPosition="end" (action)="doUpdate()">
            {{ 'update.update' | transloco }}
          </c-button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .update-needed {
      height: 100%;
      display: flex;
      flex-direction: column;
      background: white;
      color: black;
      overflow: hidden;
    }
    .update-needed__hero {
      position: relative;
      background: var(--c-content-background);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 3rem 2rem 1rem;
      flex: 0 0 35%;
    }
    .update-needed__logo {
      width: 60vw;
    }
    .update-needed__wave {
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 50px;
    }
    .update-needed__content {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 1.5rem 2rem 2.5rem;
      overflow: hidden;
      color: black;
    }
    .update-needed__title {
      font-size: 1.4rem;
      font-weight: 700;
      margin: 0 0 0.75rem;
      line-height: 1.3;
    }
    .update-needed__text {
      margin: 0;
      line-height: 1.7;
      font-size: 0.95rem;
    }
    .update-needed__actions {
      margin-top: auto;
      padding-top: 1.5rem;
    }
  `]
})
export class UpdateNeededComponent {
  private readonly windowLocationService = inject(WindowLocationService);

  readonly icon = faArrowRight;

  doUpdate(): void {
    this.windowLocationService.openStore();
  }
}
